import '../../css/App.css'
import '../../css/FormTemplate.css'
import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios';
import { AppContext } from '../context/AppContext';
import { IAuth, IConfiguration, IViewEditForm, IViewEditFormValidation, IViewEditSelectValue } from '../../interfaces/interface';
import { IMessageResponse, IMessageSender, IMessageErrorResponse } from '../../interfaces/messageInterface';
import { ViewEditAssetContext } from '../context/ViewEditAssetContext';
import FormInternalDivTemplate from '../formTemplate/FormInternalDivTemplate';
import FormSubmitButton from '../formTemplate/FormSubmitButton';
import FormEditImg from '../formTemplate/FormEditImg';
import FormErrorDivTemplate from '../formTemplate/FormErrorDivTemplate';

function ViewEditAssetForm() {
    const { navBarStatus, config, authorization, disMessage, errorHandlerFunction } = useContext(AppContext); 
    const { form, formVal, formEdit, errMessage, newIdAssetInfo, fieldEnable, valueSelectObj } = useContext(ViewEditAssetContext); 
    const [isNavbarOpen] = navBarStatus;
    const [configuration] :IConfiguration[] = config;
    const [,setConfiguration] :React.Dispatch<React.SetStateAction<IConfiguration>>[] = config;
    const [ auth ]: IAuth[] = authorization;
    const [formInput]: IViewEditForm[] = form;     
    const [,setFormInput]: React.Dispatch<React.SetStateAction<IViewEditForm>>[] = form;
    const [formInputEdit]: IViewEditForm[] = formEdit;     
    const [,setFormInputEdit]: React.Dispatch<React.SetStateAction<IViewEditForm>>[] = formEdit;
    const [displayMessage]: string[] = disMessage;
    const [,setDisplayMessage]: React.Dispatch<React.SetStateAction<string>>[] = disMessage;
    const [formFieldsValid]:IViewEditFormValidation[] = formVal;
    const [,setFormFieldsValid]:React.Dispatch<React.SetStateAction<IViewEditFormValidation>>[] = formVal;
    const [addNewType, setAddNewType] = useState<boolean>(false);
    const [assetNamesArr, setAssetNamesArr] = useState<string[]>([]);
    const [deviceIdArr, setDeviceIdArr] = useState<string[]>([]);
    const [allowEdit, setAllowEdit] = useState<boolean>(false);
    const [isFieldEnable,setIsFieldEnable] = fieldEnable;
    const [, setAssetInfoOfNewId] = newIdAssetInfo;
    const [errorMessage]:string[] = errMessage;
    const [,setErrorMessage]: React.Dispatch<React.SetStateAction<string>>[] = errMessage;
    const errorHandler: (status: number) => string = errorHandlerFunction; 
    const [selectValueObj]: IViewEditSelectValue[] = valueSelectObj;
    const [, setSelectValueObj]: React.Dispatch<React.SetStateAction<IViewEditSelectValue>>[] = valueSelectObj;
   useEffect(() => {
    if(displayMessage === "done"){
        clearFields();
    }
   },[displayMessage])

   useEffect(() => {
    if(allowEdit === false){
        setFormInput({...formInput,
            deviceId: "",
            loadSensorId: "",
            assetType: "",
            assetDescription: "",
            profile: "",
            state: "",
        });
        setSelectValueObj({
            type: "",
            newType: "",
            profile: "",
            state: "",
        })
        setAddNewType(false)
    }
   },[allowEdit])

    const clearFields = ():void => {
        setFormInput({
            assetName: "",
            deviceId: "",
            assetType: "",
            assetDescription: "",
            profile: ""
        })
        setFormInputEdit({
            assetName: "",
            deviceId: "",
            loadSensorId: "",
            assetType: "",
            assetDescription: "",
            profile: ""
        })
        setSelectValueObj({
            type: "",
            newType: "",
            profile: "",
            state: "",
        })
        let tempFormFieldsValid = formFieldsValid
        Object.entries(formFieldsValid).forEach(([key, value])=> {
        if(key === "assetName" || key === "deviceId" ||
            key === "assetType"
            ){
            tempFormFieldsValid[key]= {
                displayMessage: false,
                message: ""
            }
        }
        })
        setFormFieldsValid(tempFormFieldsValid)
        setAllowEdit(false)
        setIsFieldEnable({
            assetName: {field :true, edit: false},
            deviceId: {field :true, edit: false},
            assetType: {field :false, edit: false},
            assetDescription:{field :false, edit: false},  
            profile:{field :false, edit: false},  
            state:{field :false, edit: false}  
        })
        setAssetNamesArr([])
        setDeviceIdArr([])
        setAddNewType(false)
        setAssetInfoOfNewId({
            assetName: "",
            deviceId: "",
          })
    }
    const isDisabled = (): boolean => {
        if(displayMessage !== "none" || isNavbarOpen === true) return true
        return false
    }
    const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault(); 
        if(formValidation()){
            setDisplayMessage("asset-details");
        }
    }
    const formValidation = ():boolean => {
        if(!allowEdit) return false;
        // if((formInput.assetType === formInputEdit.assetType) && 
        // (formInput.assetDescription === formInputEdit.assetDescription) &&
        // (formInput.deviceId === formInputEdit.deviceId)&&
        // (formInput.profile === formInputEdit.profile)&&
        // (formInput.state === formInputEdit.state)&&
        // (formInput.state !== "Sleep")){
        //     setErrorMessage("no changes have been made, no update required")
        //     setDisplayMessage("info");
        //     return false ;
        // }
        if(formInputEdit.assetType === ""){
            setFormFieldsValid({
                ...formFieldsValid,
                assetType: {
                    displayMessage: true,
                    message: "Field cannot be empty"
                }
            })
            return false;
        }
        if(formInputEdit.deviceId === ""){
            setFormFieldsValid({
                ...formFieldsValid,
                deviceId: {
                    displayMessage: true,
                    message: "Field cannot be empty"
                }
            })
            return false;
        }
        if(formFieldsValid.deviceId.displayMessage){
            return false;
        }
        let tempFormInputEdit = {...formInputEdit}
        if(tempFormInputEdit.assetHomeLocation === ""){
            delete tempFormInputEdit.assetHomeLocation
        }
        if(tempFormInputEdit.loadSensorId === ""){
            delete tempFormInputEdit.loadSensorId
        }
        setFormInputEdit({...tempFormInputEdit})
        return true;
      
    }    
    const descriptionChangeHandler = (e:React.ChangeEvent<HTMLInputElement>):void =>  {
        let input = e.target.value;
        if(!(/'/.test(input)) && !(/"/.test(input)) && !(/`/.test(input))){ 
            setFormInputEdit({
                ...formInputEdit,
                assetDescription: input,
            });
        }
    };
    const assetNameChangeHandler = (e:React.ChangeEvent<HTMLInputElement>):void =>  {
        let input = e.target.value;
        if(!(/'/.test(input)) && !(/"/.test(input)) && !(/`/.test(input))){ 
            if(!isFieldEnable.assetName.edit){
                setFormInput({...formInput,
                    assetName: input
                });
                if(input.length >= 3){                                
                    let messageBody:IMessageSender  = {
                        type: 'getAssetNames',
                        userId: auth.username,
                        data: input
                    }
                    /*axios.post('/message',messageBody *//*For Cookie*/
                    axios.post('/message',messageBody, auth.header
                    ).then(res => {                                
                        if(res.data.status === "OK"){
                            setAssetNamesArr(res.data.names)
                            setFormFieldsValid({
                                ...formFieldsValid,
                                assetName:{
                                displayMessage: false,
                                message: ""
                                }
                            })                        
                            isDeviceIncludes(res.data.names, input, "assetName");
                        }else{
                            setAssetNamesArr([])
                            setFormFieldsValid({
                                ...formFieldsValid,
                                assetName:{
                                displayMessage: true,
                                message: res.data.errorDescription
                                }
                            })
                        }
                    }).catch(({response}:IMessageErrorResponse) => {
                        const errorMessage = errorHandler(response.data.status)
                        setErrorMessage(errorMessage)
                        setDisplayMessage("error");
                    })
                }else{
                    setAssetNamesArr([])
                }
                setAllowEdit(false);
            }else{
                setFormInputEdit({
                    ...formInputEdit,
                    assetName: input,
                });
            }
        }
    };
    const typeBlurHandler = (e: React.FocusEvent<HTMLInputElement, Element>) => {
        if(e.target.value !== ""){
            let tempAssetTypes = configuration.assetTypes;
            tempAssetTypes.push(e.target.value);
            setSelectValueObj({
                ...selectValueObj,
                type: e.target.value,
                newType: ""
            })
            setConfiguration({
            ...configuration,
            assetTypes: [...tempAssetTypes]
            });
            setFormInputEdit({
            ...formInputEdit,
            assetType: e.target.value,
             });    
        }
        setAddNewType(false);
    }
    const selectChangeHandler = (e: React.ChangeEvent<HTMLSelectElement>):void =>  {
        if(e.target.value === "addNewType"){
            setAddNewType(true);
            setFormInputEdit({
                ...formInputEdit,
                assetType: ""
            })
        }else{            
          setFormInputEdit({
            ...formInputEdit,
            assetType: e.target.value,
          });
          if(e.target.value !== ""){
            setFormFieldsValid({
              ...formFieldsValid,
              assetType:{
                displayMessage: false,
                message: ""
              }
            })
          }
        }          
    };
    const assetTypeEditChangeHandler = (e: React.ChangeEvent<HTMLInputElement>):void => {
        let input = e.target.value;
        if(!(/'/.test(input)) && !(/"/.test(input)) && !(/`/.test(input))){ 
            setSelectValueObj({
                ...selectValueObj,
                newType: input,
            });  
        }
    }
    const deviceIdChangeHandler = (e:React.ChangeEvent<HTMLInputElement>):void =>  {
        let input = e.target.value.toUpperCase();
        if (/^[0-9a-fA-F]+$/.test(input) || input === "") {
            if(!isFieldEnable.deviceId.edit){
                setFormInput({
                ...formInput,
                deviceId: input
                })
                if(input.length >= 3){
                    let messageBody:IMessageSender  = {
                        type: 'getDeviceIDs',
                        userId: auth.username,
                        deviceIdFilter: {
                          Type: "All Trackers",
                          Pattern: input,
                        }
                      }
                    /*axios.post('/message',messageBody *//*For Cookie*/
                    axios.post('/message',messageBody, auth.header
                    ).then(res => {                                
                        if(res.data.status === "OK"){
                            setDeviceIdArr(res.data.names)
                            setFormFieldsValid({
                                ...formFieldsValid,
                                deviceId:{
                                displayMessage: false,
                                message: ""
                                }
                            })
                            isDeviceIncludes(res.data.names, input, "deviceId");
                        }else{
                        setDeviceIdArr([])
                        setFormFieldsValid({
                            ...formFieldsValid,
                            deviceId:{
                            displayMessage: true,
                            message: res.data.errorDescription
                            }
                        })
                        }
                    }).catch(({response}:IMessageErrorResponse) => {
                        const errorMessage = errorHandler(response.data.status)
                        setErrorMessage(errorMessage)
                        setDisplayMessage("error");
                      })
                }else{
                    setDeviceIdArr([])
                }
            }else{
                setFormInputEdit({
                    ...formInputEdit,
                    deviceId: input
                    })
                    if(input.length >= 3){
                        let messageBody:IMessageSender  = {
                            type: 'getDeviceIDs',
                            userId: auth.username,
                            deviceIdFilter: {
                              Type: "All Trackers",
                              Pattern: input,
                            }
                          }
                        /*axios.post('/message',messageBody *//*For Cookie*/
                        axios.post('/message',messageBody, auth.header
                        ).then(res => {                                
                            if(res.data.status === "OK"){
                                setDeviceIdArr(res.data.names)
                                setFormFieldsValid({
                                    ...formFieldsValid,
                                    deviceId:{
                                    displayMessage: false,
                                    message: ""
                                    }
                                })
                                isDeviceIncludesInEdit(res.data.names, input);
                            }else{
                            setDeviceIdArr([])
                            setFormFieldsValid({
                                ...formFieldsValid,
                                deviceId:{
                                displayMessage: true,
                                message: res.data.errorDescription
                                }
                            })
                            }
                        }).catch(({response}:IMessageErrorResponse) => {
                            const errorMessage = errorHandler(response.data.status)
                            setErrorMessage(errorMessage)
                            setDisplayMessage("error");
                          })
                    }else{
                        setDeviceIdArr([])
                    }
            }
        };
    }
    const isDeviceIncludes = (deviceArr:string[], input:string, type:string):void => {
        if(deviceArr.includes(input) && (type === "deviceId" || type === "assetName")){
            const messageBody:IMessageSender  = {
                type: 'getAssetInfo',
                userId: auth.username,
                assetInfo: {
                    [type]: input
                }
            }            
            axios.post('/message',messageBody, auth.header
            ).then(({ data }: {data :IMessageResponse})  =>{
                if(data.status === "OK"){                     
                    let assetInfo = data.assetInfo
                    console.log(assetInfo);
                    
                    setFormInput({
                        ...formInput,
                        ...assetInfo
                    })
                    setFormInputEdit({
                        ...formInput,
                        ...assetInfo
                    })
                    setSelectValueObj({
                        type: assetInfo.assetType? assetInfo.assetType : "",    
                        newType: assetInfo.assetType? assetInfo.assetType : "",    
                        profile: assetInfo.profile? assetInfo.profile : "",    
                        state: assetInfo.state? assetInfo.state : ""    
                    })  
                    setFormFieldsValid({
                        assetName: {
                        displayMessage: false,
                        message: ""
                        },
                        deviceId: {
                        displayMessage: false,
                        message: ""
                        },
                        assetType: {
                        displayMessage: false,
                        message: ""
                        },
                    })
                    setAllowEdit(true)
                }else{
                    setFormFieldsValid({
                        ...formFieldsValid,
                        [type]:{
                            displayMessage: true,
                            message: data.errorDescription
                          }
                    })
                }
            }).catch(({response}:IMessageErrorResponse) => {
                const errorMessage = errorHandler(response.data.status)
                setErrorMessage(errorMessage)
                setDisplayMessage("error");
              })
        }else{
            setIsFieldEnable({
                assetName: {field :true, edit: false},
                deviceId: {field :true, edit: false},
                assetType: {field :false, edit: false},
                assetDescription:{field :false, edit: false},  
                profile:{field :false, edit: false},  
                state:{field :false, edit: false}  
            })
        }
    }
    const isDeviceIncludesInEdit = (deviceArr:string[], input:string) => {
        if(deviceArr.includes(input)){
            const messageBody:IMessageSender  = {
                type: 'getAssetInfo',
                userId: auth.username,
                assetInfo: {
                    deviceId: input
                }
            }            
            axios.post('/message',messageBody, auth.header
            ).then(({ data }: {data :IMessageResponse})  =>{
                if(data.status === "OK"){
                    if(data.assetInfo.assetName !== "" && data.assetInfo.assetName !== formInput.assetName){
                        setAssetInfoOfNewId({...data.assetInfo})
                        setDisplayMessage("deviceId-edit-error")
                    }             
                }else{
                    setFormFieldsValid({
                        ...formFieldsValid,
                        deviceId:{
                            displayMessage: true,
                            message: data.errorDescription
                          }
                    })
                }
            }).catch(({response}:IMessageErrorResponse) => {
                const errorMessage = errorHandler(response.data.status)
                setErrorMessage(errorMessage)
                setDisplayMessage("error");
              })
        }
    }
    const editClickHandler = (e: any):void => {
        if(allowEdit){
            const targetId:string = e.target.id.slice(4)
            if(targetId === "assetType" || targetId === "assetDescription" ||
                 targetId === "deviceId"|| targetId === "profile"|| targetId === "state"){
                if(isFieldEnable[targetId].edit) {
                    setIsFieldEnable({
                        ...isFieldEnable,
                        [targetId]: {
                            field: false,
                            edit: false
                        }
                    })
                }else{
                    setIsFieldEnable({
                        ...isFieldEnable,
                        [targetId]: {
                            field: true,
                            edit: true
                        }
                    })
                }       
            }
            if(targetId === "assetName"){
                if(isFieldEnable[targetId].edit) {
                    setIsFieldEnable({
                        ...isFieldEnable,
                        [targetId]: {
                            field: true,
                            edit: false
                        }
                    })
                }else{
                    setIsFieldEnable({
                        ...isFieldEnable,
                        [targetId]: {
                            field: true,
                            edit: true
                        }
                    })
                }     
            }
        }
    }
    const editAssetNameButtonHandler = (e:any):void => {
        if(formInputEdit.assetName !== formInput.assetName){
            let operation:string;
            if(e.target.name === "rename-and-keep-button"){
                operation = "rename"
            }else{
                operation = "keep"
            }
            let messageBody:IMessageSender  = {
                type: 'renameAsset',
                userId: auth.username,
                renameAsset: {
                    oldAssetName: formInput.assetName,
                    newAssetName: formInputEdit.assetName,
                    operation: operation
                }
            }
            try{
                axios.post('/message',messageBody, auth.header
                ).then(res => {
                    if(res.data.status === "OK"){
                        setFormInput({
                            ...formInput,
                            assetName: formInputEdit.assetName
                        })
                        setFormFieldsValid({
                            ...formFieldsValid,
                            assetName:{
                                displayMessage: false,
                                message: ""
                            }
                        })
                        setDisplayMessage("rename-successful")
                        setIsFieldEnable({
                            ...isFieldEnable,
                            assetName: {
                                field: true,
                                edit: false
                            }
                        })
                        setTimeout(() => {
                            setDisplayMessage("none")
                          },1000)
                    }else{
                        if (res.data.errorDescription) {
                            alert("ERROR:\n"+res.data.errorDescription);
                        }
                        setFormFieldsValid({
                            ...formFieldsValid,
                            assetName:{
                                displayMessage: true,
                                message: errorMessage
                            }
                        })
                        
                    }
                }).catch(({response}:IMessageErrorResponse) => {
                    const errorMessage = errorHandler(response.data.status);
                    setErrorMessage(errorMessage)
                    setDisplayMessage("error");
                  })
            }catch{
                
                throw new Error("The server is unavailable at this moment. please try again later...");
            }
    }else{
        setFormFieldsValid({
            ...formFieldsValid,
            assetName:{
                displayMessage: true,
                message: "No changes have been made"
            }
        })
    }
    
    }

    const profileStateChangeHandler = (e: React.ChangeEvent<HTMLSelectElement>):void => {
        setFormInputEdit({
          ...formInputEdit,
          [e.target.name]: e.target.value,
        })
        if(e.target.name === "state" && e.target.value === "Sleep"){
          setDisplayMessage("warning")
        }
      }
return (
    <form className="form-template" onSubmit={submitHandler}>
            <div className='form-template-top-container'>
                < FormInternalDivTemplate
                    id="assetName"
                    label="Asset Name"
                    type="list"
                    value={isFieldEnable.assetName.edit?formInputEdit.assetName :formInput.assetName}
                    maxLength={32}
                    displayMessage={formFieldsValid.assetName.displayMessage}
                    message={formFieldsValid.assetName.message}
                    onChange={assetNameChangeHandler}
                    listId="assetsNamesId"
                    array={assetNamesArr}
                    disabled={isFieldEnable.assetName.field? isDisabled() : true}
                    edit={isFieldEnable.assetName.edit}
                    editClickHandler={editClickHandler}
                />
                {isFieldEnable.assetName.edit && 
                    <div className='rename-button-container'>
                        <button type='button' name='rename-and-keep-button' className="edit-asset-name-button rename-keep" 
                        disabled={isDisabled()} onClick={editAssetNameButtonHandler}>
                            Rename <br></br><b>rename</b> history
                        </button>
                        <button type='button' name='rename-and-delete-button' className="edit-asset-name-button rename-delete" 
                        disabled={isDisabled()} onClick={editAssetNameButtonHandler}>
                            Rename <br></br><b>keep</b> history
                        </button>
                    </div>

                }
                < FormInternalDivTemplate
                    id="deviceId"
                    label="Tracker ID"
                    type="list"
                    value={isFieldEnable.deviceId.edit?formInputEdit.deviceId :formInput.deviceId}
                    maxLength={8}
                    displayMessage={formFieldsValid.deviceId.displayMessage}
                    message={formFieldsValid.deviceId.message}
                    onChange={deviceIdChangeHandler}
                    listId="trackersId"
                    array={deviceIdArr}
                    disabled={isFieldEnable.deviceId.field? isDisabled() : true}
                    edit={isFieldEnable.deviceId.edit}
                    editClickHandler={editClickHandler}
                />
                {(formInput.loadSensorId && formInput.loadSensorId !== "") &&
                    < FormInternalDivTemplate
                        id="loadSensor"
                        label="Load Sensor ID"
                        type="text"
                        value={formInput.loadSensorId}
                        maxLength={8}
                        disabled={true}
                        errorSpace={true}
                    />
                }
                <div className="form-template-internal-div">
                    <label htmlFor="assetType"  className="form-template-label" >Asset Type </label>
                    <div className='form-template-select-div-icon'>
                        {
                        !addNewType?
                        <>  
                            <select className="form-template-input-select" 
                                name="assetType" id="assetType" 
                                onChange={selectChangeHandler}
                                disabled={isFieldEnable.assetType.field? isDisabled() : true}
                            >
                                <option disabled  selected={selectValueObj.type === ""? true : false }
                                  className="form-template-select-option" value="">Please choose type... </option>
                                <option className="form-template-select-option" value="addNewType">+ add new type</option>
                                {configuration?.assetTypes.map((assetType, i) => {
                                if(selectValueObj.type === assetType){
                                    return <option selected className="form-template-select-option" value={assetType}>{assetType}</option>
                                }
                                return <option className="form-template-select-option" value={assetType}>{assetType}</option>    
                                })    
                                }
                            </select>
                            <FormEditImg id="assetType" edit={isFieldEnable.assetType.edit} editClickHandler={editClickHandler} />
                        </>       
                        :
                        <>
                            <input 
                                name="assetTypeInput" 
                                id="assetTypeInput" 
                                className="form-template-input" 
                                onChange={assetTypeEditChangeHandler}
                                value={selectValueObj.newType}
                                placeholder='Please enter new Type'
                                maxLength={24}
                                disabled={isDisabled()}
                                onBlur={typeBlurHandler}
                            />
                            <FormEditImg id="assetType" edit={isFieldEnable.assetType.edit} editClickHandler={editClickHandler}   />
                        </>
                        }
                    </div>  
                    <FormErrorDivTemplate displayMessage={formFieldsValid.assetType.displayMessage} message={formFieldsValid.assetType.message}/>
                </div>
                < FormInternalDivTemplate
                    id="assetDescription"
                    label="Description"
                    type="text"
                    value={formInputEdit.assetDescription}
                    maxLength={64}
                    onChange={descriptionChangeHandler}
                    disabled={isFieldEnable.assetDescription.field? isDisabled() : true} 
                    edit={isFieldEnable.assetDescription.edit}
                    editClickHandler={editClickHandler}
                    errorSpace={true}
                />
                {
                    configuration.profiles &&
                        <div className="form-template-internal-div">
                            <label htmlFor="profile"  className="form-template-label" >Profile </label>
                            <div className='form-template-select-div-icon'>
                                <select className="form-template-input-select" 
                                    name="profile" id="profile" 
                                    onChange={profileStateChangeHandler}
                                    disabled={isFieldEnable.profile.field? isDisabled() : true}
                                >
                                    <option  selected={selectValueObj.profile === ""? true : false }
                                    className="form-template-select-option" value="">Please choose profile... </option>
                                    {configuration.profiles.map((option) => {
                                    if(selectValueObj.profile === option){
                                        return <option selected className="form-template-select-option" value={option}>{option}</option>
                                    }
                                    return <option className="form-template-select-option" value={option}>{option}</option>    
                                    })    
                                    }
                                </select>
                                <FormEditImg id="profile" edit={isFieldEnable.profile.edit} editClickHandler={editClickHandler} />                       
                            </div>  
                        </div>
                }
                {
                    configuration.states &&
                        <div className="form-template-internal-div">
                            <label htmlFor="state"  className="form-template-label" >State </label>
                            <div className='form-template-select-div-icon'>
                                <select className="form-template-input-select" 
                                    name="state" id="state" 
                                    onChange={profileStateChangeHandler}
                                    // disabled={isFieldEnable.state.field? isDisabled() : true}
                                    disabled={true}
                                >
                                    <option  selected={selectValueObj.state === ""? true : false }
                                    className="form-template-select-option" value="">Please choose state... </option>
                                    {configuration.states.map((option) => {
                                    if(selectValueObj.state === option){
                                        return <option selected className="form-template-select-option" value={option}>{option}</option>
                                    }
                                    return <option className="form-template-select-option" value={option}>{option}</option>    
                                    })    
                                    }
                                </select>
                                <FormEditImg id="state" edit={isFieldEnable.state.edit} editClickHandler={editClickHandler} />                       
                            </div>  
                        </div>
                }
            </div>  
            <FormSubmitButton text="Update" disabled={isDisabled()} />  
        </form>
    );
}

export default ViewEditAssetForm;